import { IPeriodoFerias } from '@core/models';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '@store/store';

interface IPeriodoFeriasState {
  data: IPeriodoFerias[];
  loading: boolean;
  error: string | null;
}

const initialState: IPeriodoFeriasState = {
  data: [] as IPeriodoFerias[],
  error: null,
  loading: false
};

export const periodoFeriasSlice = createSlice({
  name: 'periodoFerias',
  initialState,
  reducers: {
    periodoFerias_fetching: (state) => {
      state.loading = true;
      state.data = [] as IPeriodoFerias[];
      state.error = null;
    },
    periodoFerias_success: (state, action: PayloadAction<IPeriodoFerias[]>) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    periodoFerias_error: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
      state.data = [] as IPeriodoFerias[];
    }
  }
});

export const { periodoFerias_fetching, periodoFerias_success, periodoFerias_error } = periodoFeriasSlice.actions;

export const selectorPeriodoFerias = (state: AppState) => state.periodoFerias;

export default periodoFeriasSlice.reducer;
